import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import "../../../styles/navbar.scss";
import { Link as Li } from "react-router-dom";
import { useHistory } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import Accordion from "@material-ui/core/Accordion";
import { split } from "lodash";
import { useGAEventsTracker } from "../../../util/gtag";
import ModalNewContactUs from "../../pages/Modalpopup/ModalNewContactUs";
import config from "../../config/config";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
// import { backdropClasses } from "@mui/material";

const useStyles = makeStyles(() => ({
  title: {
    flexGrow: 1,
  },
  header: {
    backgroundColor: "#fff",
    color: "black",
    "@media (max-width: 900px)": {
      paddingLeft: 0,
    },
  },
  logo: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "black",
    textAlign: "left",
    width: "100%",
  },
  menuButton: {
    fontWeight: 700,
    size: "18px",
    marginLeft: "38px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

export default function NewNavbar(props) {
  const location = useLocation();
  const pathname = location?.pathname || "";

  // GA trackers (SAFE)
  const GAEventTracker = useGAEventsTracker(pathname);
  const GAEventTrackerContact = useGAEventsTracker(
    `${pathname}/Contact Us`
  );
  const GAEventTrackerHowItWorks = useGAEventsTracker(
    `${pathname}/How It Works`
  );
  const GAEventTrackerFaq = useGAEventsTracker(
    `${pathname}/FAQs`
  );


  const history = useHistory();
  const [openSubmit, setOpenSubmit] = React.useState(false);
  const [drawerstate, setDrawerState] = useState(false);
  const handleClickOpen2 = () => {
    setOpenSubmit(!openSubmit);
  };
  const { header, logo, toolbar } = useStyles();
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView } = state;
  const handleHome = () => {
    setDrawerState(!drawerstate);
    setTimeout(() => {
      let ele = document.getElementById("new-home");
      ele.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }, 100);
  };
  const menuClicked = (e) => {
    e.stopPropagation();
  };
  const handleMobileMenu = (event, state) => {
    event.stopPropagation();
    setDrawerState(state);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
  };
  const handleFaqMobile = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      if (!props?.partner?.url_path) return;
      history.push(`/lender/${props.partner.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("faq");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleHowItWorks = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      if (!props?.partner?.url_path) return;
      history.push(`/lender/${props.partner.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("trade");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleDesktopHowItWorks = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      if (!props?.partner?.url_path) return;
      history.push(`/lender/${props.partner.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("trade");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleDesktopFaq = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      if (!props?.partner?.url_path) return;
      history.push(`/lender/${props.partner.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("faq");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleWhyWorkWithUs = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      if (!props?.partner?.url_path) return;
      history.push(`/lender/${props.partner.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("whyworkwithus");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };

  const handleCalculator = () => {
    const currentURL = window.location.href;
    const urlObj = new URL(currentURL);
    const pathSegments = urlObj.pathname.split("/");
    const isCalculator = pathSegments.includes("lender");
    // const isBuilderCalculator = pathSegments.includes("builder-calculator");
    // if (isCalculator) {
      history.push(`/${props?.partner?.url_path}/calculator`);
    // } else if (isBuilderCalculator) {
    //   history.push(`/builder-calculator`);
    // } else {
    //   history.push(`/builder/${props?.partner?.url_path}/calculator`);
    // }
  };

  const mobileNav = () => {
    return (
      <div className="new-mob-navbar inter">
        <div className="partner_navbar_mob">
          <div>
            {props?.pathname && props?.pathname.length !== 0 ? (
              props?.partner?.url_path === "hometown" ? (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${config.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "120px",
                        height: "68px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-3">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="142px"
                        height="45px"
                        className="mt-3"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : props?.partner?.url_path === "nrl" ||
                props?.partner?.url_path === "firstfederal" ? (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${config.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "110px",
                        height: "50px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-3">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="140px"
                        height="42px"
                        className="mt-3"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : props?.pathname?.url_path === "teamnikkijames" ? (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${config.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "120px",
                        height: "68px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="98px"
                        height="35px"
                        className="mt-1"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : props?.partner?.url_path === "gvc" ? (
                <div className="partner_navbar_sub_mob">
                  <div style={{ display: "flex", height: "35px" }}>
                    <img
                      src={`${config.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "150px",
                        height: "80px",
                        objectFit: "contain",
                        paddingBottom: "50px",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="98px"
                        height="35px"
                        className="mt-1"
                      ></img>
                    </Li>
                  </div>
                </div>
                ) : props?.partner?.url_path === "rocketpro" ? (
                  <div className="partner_navbar_sub_mob">
                    <div style={{ display: "flex", height: "35px" }}>
                      <img
                        src={`${config.mainUrl}${props?.partner?.logo}`}
                        alt="Logo"
                        className=""
                        style={{
                          width: "50px",
                          height: "90px",
                          objectFit: "contain",
                          paddingBottom: "50px",
                        }}
                      ></img>
                    </div>
                    <div className="px-2 partner_header_plus mt-1">+</div>
                    <div className="partner_header_logo_calque">
                      <Li
                        to={`/${props?.partner?.url_path}`}
                        onClick={(e) => {
                          GAEventTracker("Home");
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="140" height="24" viewBox="0 0 188 14" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M47.1177 7.31042C47.1177 11.0973 44.6819 14.1271 40.0385 14.4745L47.8692 22.8045C48.0821 23.0307 47.9216 23.4014 47.6111 23.4014H43.0384C42.9225 23.4014 42.812 23.3526 42.7336 23.2672L34.6809 14.4756H34.4588V23.0481C34.4588 23.2438 34.3001 23.4026 34.1044 23.4026H30.2619C30.0662 23.4026 29.9074 23.2438 29.9074 23.0481V0.48194C29.9074 0.286224 30.0662 0.127463 30.2619 0.127463H40.1192C42.5678 0.114455 47.118 1.83894 47.1177 7.31042ZM34.4585 4.12456V10.8682L38.398 10.8685C39.8449 10.8685 40.9352 10.5613 41.6699 9.95406C42.4034 9.34592 42.7709 8.50482 42.7709 7.43577C42.7709 6.40693 42.4365 5.59657 41.7704 5.00824C41.1017 4.42228 40.1355 4.12456 38.8657 4.12456H34.4585Z" fill="#DE3341">
                        </path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M47.4914 14.475C47.4914 9.35923 51.6384 5.21223 56.7542 5.21223C61.87 5.21223 66.017 9.35923 66.017 14.475C66.017 19.5909 61.87 23.7378 56.7542 23.7378C51.6384 23.7378 47.4914 19.5909 47.4914 14.475ZM51.5503 14.4753C51.5503 17.3496 53.88 19.6793 56.7542 19.6793C59.6284 19.6793 61.9581 17.3496 61.9581 14.4753C61.9581 11.6011 59.6284 9.27142 56.7542 9.27142C53.88 9.27142 51.5503 11.6011 51.5503 14.4753Z" fill="#DE3341">
                        </path>
                        <path d="M131.651 23.0993V20.212C131.651 19.9847 131.441 19.8152 131.219 19.8667C130.036 20.1416 127.443 20.1443 127.443 16.9981V9.03609H131.297C131.493 9.03609 131.652 8.87733 131.652 8.68161V5.87655C131.652 5.68083 131.493 5.52207 131.297 5.52207H127.443V0.477801C127.443 0.199896 127.137 0.0299009 126.902 0.177131L123.079 2.55913C122.975 2.62388 122.912 2.7374 122.912 2.8598V5.52177H120.452C120.257 5.52177 120.098 5.68053 120.098 5.87625V8.68132C120.098 8.87703 120.257 9.03579 120.452 9.03579H122.907V17.3256C122.907 22.8146 127.561 23.7381 129.356 23.7381C130.093 23.7381 130.678 23.6042 131.169 23.4914C131.24 23.4753 131.308 23.4597 131.375 23.4449C131.537 23.4091 131.651 23.2651 131.651 23.0993Z" fill="#DE3341"></path>
                        <path d="M103.077 23.4014C103.387 23.4014 103.547 23.0316 103.335 22.8051L95.5506 14.4753L102.623 6.10478C102.817 5.87448 102.653 5.52177 102.352 5.52177H97.9332C97.8108 5.52177 97.6949 5.57588 97.6163 5.66989L91.8276 12.5879H91.5707V0.478688C91.5707 0.200192 91.2644 0.0304922 91.0284 0.178018L87.2052 2.56593C87.1014 2.63068 87.0384 2.7445 87.0384 2.8666V23.0469C87.0384 23.2426 87.1972 23.4014 87.3929 23.4014H91.2162C91.4119 23.4014 91.5707 23.2426 91.5707 23.0469V16.2681H91.7803L98.1697 23.3237C98.2144 23.3733 98.2779 23.4014 98.3447 23.4014H103.077Z" fill="#DE3341"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M106.251 6.45512C107.691 5.63175 109.27 5.21401 110.946 5.21401C114.62 5.21401 117.407 7.19423 118.834 9.58539C120.346 12.1184 120.038 14.7261 119.988 15.1528C119.987 15.1631 119.986 15.1721 119.985 15.1799C119.964 15.3643 119.902 15.6275 119.851 15.8229C119.811 15.9793 119.67 16.0881 119.508 16.0881H105.899C106.023 16.627 106.854 20.0627 110.946 20.0627C112.76 20.0627 114.144 19.2852 114.78 18.5614C114.858 18.4724 114.971 18.4219 115.089 18.4219H118.8C119.067 18.4219 119.238 18.7054 119.115 18.9416C118.303 20.4875 116.808 22.0243 114.702 22.968C113.561 23.4797 112.309 23.739 110.984 23.739C109.258 23.739 107.653 23.3266 106.214 22.516C103.76 21.1329 101.515 18.4136 101.515 14.4756C101.515 14.4707 101.515 14.4636 101.515 14.4543C101.511 14.0343 101.459 9.19333 106.251 6.45512ZM110.947 8.859C108.365 8.859 106.416 10.551 105.871 12.9433H115.797C115.652 12.2415 114.631 8.859 110.947 8.859Z" fill="#DE3341">
                        </path>
                        <path d="M76.6339 19.6796C73.759 19.6796 71.4296 17.3493 71.4296 14.4753C71.4296 11.6017 73.759 9.27083 76.6342 9.27083C78.889 9.27083 80.8083 10.7059 81.5312 12.7127C81.5809 12.852 81.7145 12.943 81.8632 12.943H85.3394C85.7367 12.943 85.6939 12.5418 85.6814 12.4862C85.643 12.3124 85.5753 12.0484 85.5233 11.8704C84.3989 8.02292 80.8453 5.21223 76.6342 5.21223C71.5183 5.21223 67.3714 9.35923 67.3714 14.475C67.3714 19.5909 71.5183 23.7378 76.6342 23.7378C81.0469 23.7378 84.7354 20.6525 85.6673 16.5209L85.6687 16.515C85.7137 16.2965 85.5449 16.0893 85.3205 16.0893H81.8313C81.6846 16.0893 81.5537 16.1785 81.5016 16.3142C80.7587 18.2812 78.8604 19.6796 76.6339 19.6796Z" fill="#DE3341"></path>
                        <path d="M6.63552 12.9058V23.3452C6.63552 23.6217 6.33307 23.7881 6.09685 23.6444C2.48409 21.4457 0.0571532 17.4918 0.000980915 12.967C-0.085347 6.00693 5.5375 0.226513 12.4975 0.129542C19.582 0.031093 25.356 5.7444 25.356 12.8061C25.356 17.4288 22.8817 21.4732 19.1856 23.6882C19.0446 23.7727 18.8627 23.745 18.7501 23.6252L14.4952 19.0968C14.3202 18.9106 14.3959 18.6064 14.6377 18.5236C17.0129 17.7097 18.7205 15.4575 18.7205 12.8064C18.7205 9.43492 15.9592 6.7082 12.5747 6.76467C9.26142 6.81995 6.63552 9.59191 6.63552 12.9058Z" fill="#DE3341"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M149.475 15.0034C154.102 15.0034 156.85 11.236 156.85 7.44907C156.85 1.9773 152.3 0.253106 149.851 0.266114H139.994C139.798 0.266114 139.639 0.424875 139.639 0.620591V23.1868C139.639 23.3825 139.798 23.5412 139.994 23.5412H143.836C144.032 23.5412 144.19 23.3825 144.19 23.1868V15.0045L149.475 15.0034ZM144.19 11.0068V4.26321H148.598C149.867 4.26321 150.834 4.56093 151.502 5.14689C152.168 5.73493 152.503 6.54529 152.503 7.57412C152.503 8.64317 152.135 9.48398 151.402 10.0924C150.667 10.6997 149.577 11.0068 148.13 11.0068H144.19Z" fill="#DE3341"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M178.113 5.35118C172.997 5.35118 168.85 9.49817 168.85 14.6143C168.85 19.7304 172.997 23.8771 178.113 23.8771C183.229 23.8771 187.376 19.7301 187.376 14.6143C187.376 9.49846 183.229 5.35118 178.113 5.35118ZM178.113 19.8182C175.239 19.8182 172.909 17.4885 172.909 14.6143C172.909 11.74 175.239 9.41036 178.113 9.41036C180.987 9.41036 183.317 11.74 183.317 14.6143C183.317 17.4885 180.987 19.8182 178.113 19.8182Z" fill="#DE3341"></path><path d="M158.516 6.01549C158.516 5.81948 158.675 5.66101 158.871 5.66101L162.028 5.66219C162.224 5.66249 162.383 5.82096 162.383 6.01667V7.72638H162.508C163.195 6.8223 164.909 5.35118 167.163 5.35118C167.764 5.35118 168.24 5.40942 168.525 5.45613C168.697 5.48392 168.82 5.63204 168.82 5.80558V8.72388C168.82 8.99764 168.581 9.21021 168.309 9.17474C168.005 9.13512 167.577 9.09728 167.052 9.09728C164.422 9.09728 162.788 10.7674 162.788 13.4557V23.1868C162.788 23.3825 162.629 23.5412 162.433 23.5412H158.871C158.675 23.5412 158.516 23.3825 158.516 23.1868V6.01549Z" fill="#DE3341"></path>
                        </svg>
                      </Li>
                    </div>
                  </div>
              ) : props?.partner?.url_path === "rvwarburton" ? (
                <div className="partner_navbar_sub_mob">
                  <div style={{ display: "flex", height: "35px" }}>
                    <img
                      src={`${config.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "40px",
                        height: "90px",
                        objectFit: "contain",
                        paddingBottom: "50px",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div style={{ display: "flex", height: "35px" }}>
                    <img
                      src="/assets/partner_logos/Warburton.png"
                      alt="Logo"
                      className=""
                      style={{
                        width: "66px",
                        height: "36px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="98px"
                        height="35px"
                        className="mt-1"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${config.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "120px",
                        height: "68px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus" style={{ display : props?.partner?.url_path === "bbys" ? 'none' : 'block'}}>+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="115px"
                        height="35px"
                        style={{ display : props?.partner?.url_path === "bbys" ? 'none' : 'block'}}
                      ></img>
                    </Li>
                  </div>
                </div>
              )
            ) : (
              ""
            )}
          </div>
          <div>
            <div
              onClick={(e) => handleMobileMenu(e, !drawerstate)}
              onKeyDown={(e) => handleMobileMenu(e, !drawerstate)}
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center justify-content-center"
            >
              <MenuIcon />
            </div>
          </div>
        </div>
        {drawerstate === true && (
          <div
            id="mobilemenu"
            style={{
              position: "absolute",
              width: "100%",
              backgroundColor: "#fff",
              top: "3.5rem",
              borderTop: "1px solid #eee",
            }}
            onClick={menuClicked}
          >
            <div id="menuAccordian">
              <Accordion className="p-2 pl-4">
                <Li
                  activeclass="active"
                  to={`/${props?.partner?.url_path}`}
                  href={`/${props?.partner?.url_path}`}
                  onClick={(e) => {
                    GAEventTracker("Home");
                    handleHome();
                  }}
                  spy={true}
                  smooth="true"
                  offset={-70}
                  className={
                    props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""
                  }
                  duration={500}
                >
                  Home
                </Li>
              </Accordion>
              <Accordion className="p-2 pl-4">
                <Link
                  activeclass="active"
                  to="trade"
                  spy={true}
                  smooth="true"
                  offset={-70}
                  onClick={(e) => {
                    GAEventTrackerHowItWorks("Header", 1);
                    handleHowItWorks();
                  }}
                  className={
                    props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""
                  }
                  duration={500}
                >
                  How It Works
                </Link>
              </Accordion>
              <Accordion className="p-2 pl-4">
                <Link
                  activeclass="active"
                  to="whyworkwithus"
                  spy={true}
                  smooth="true"
                  offset={-70}
                  onClick={(e) => {
                    GAEventTrackerHowItWorks("Header", 1);
                    handleWhyWorkWithUs();
                  }}
                  className={
                    props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""
                  }
                  duration={500}
                >
                  Why Work With Us?
                </Link>
              </Accordion>
              

              <Accordion className="p-2 pl-4">
                <Link
                  activeclass="active"
                  className={
                    props?.partner?.url_path === "c2"
                      ? "ftpolar-semibold faqs"
                      : "faqs"
                  }
                  to="faq"
                  spy={true}
                  smooth="true"
                  offset={-70}
                  duration={500}
                  onClick={(e) => {
                    GAEventTrackerFaq("Header", 1);
                    handleFaqMobile();
                  }}
                >
                  FAQs
                </Link>
              </Accordion>
              {/* <Accordion className="p-2 pl-4">
                <Link activeclass="active"
                  className={props?.partner?.url_path === "c2" ? "ftpolar-semibold faqs" : "faqs"}
                  // to="/calculator"
                  spy={true}
                  smooth="true"
                  offset={-70}
                  duration={500}
                  onClick={(e) => { handleCalculator() }}
                  >
                  Calculator
                </Link>
               </Accordion> */}
              {/* <Accordion className="p-2 pl-4">
                <Li
                  activeclass="active"
                  disabled={!props?.partner?.url_path}
                  style={{backgroundColor:"blue"}}
                  onClick={(e) => {

                    if (typeof GAEventTrackerContact === "function") {
                      GAEventTrackerContact("Contact Us", 1);
                    }
                    handleClickOpen2();
                  }}
                >
                  Contact
                </Li>
              </Accordion> */}
              <Accordion className="p-2 pl-4">
                <div
                  className="mobile-contact-link"
                  role="button"
                  style={{color:"#007bff"}}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (typeof GAEventTrackerContact === "function") {
                      GAEventTrackerContact("Contact Us", 1);
                    }
                    handleClickOpen2();
                  }}
                >
                  Contact
                </div>
              </Accordion>
            </div>
          </div>
        )}
      </div>
    );
  };

  const desktopNav = () => {
    return (
      <Toolbar className={`new-navbar inter ${toolbar}`}>
        <div className="col-5">
          <Typography variant="h6" component="h1" className={logo}>
            <div className="login_img d-flex align-items-center justify-content-start">
              {props.pathname && props.pathname.length !== 0 ? (
                <>
                  <Li
                    to={`/${props?.partner?.url_path}`}
                    style={
                      props?.partner?.url_path === "gvc"
                        ? { display: "flex" }
                        : {}
                    }
                    onClick={(e) => {
                      GAEventTracker("Home");
                    }}
                  >
                    {props?.partner?.url_path === "synergy" ||
                    props?.partner?.url_path === "integrity" ? (
                      <img
                        src={`${config.mainUrl}${props?.partner?.logo}`}
                        alt="Logo"
                        className=""
                        style={{
                          width: "168px",
                          height: "68px",
                          objectFit: "contain",
                        }}
                      ></img>
                    ) :
                    props?.partner?.url_path === "rocketpro" ? (
                      <img
                        src={`${config.mainUrl}${props?.partner?.logo}`}
                        alt="Logo"
                        className=""
                        style={{
                          width: "85px",
                          height: "68px",
                          objectFit: "contain",
                        }}
                      ></img>
                    ) 
                    :props?.partner?.url_path === "bbys" ? (
                      <img
                        src={`${config.mainUrl}${props?.partner?.logo}`}
                        alt="Logo"
                        className=""
                        style={{
                          width: "140px",
                          height: "68px",
                          objectFit: "contain",
                        }}
                      ></img>
                    ) 
                    :
                    (
                      <img
                        src={`${config.mainUrl}${props?.partner?.logo}`}
                        alt="Logo"
                        className=""
                        style={{
                          width: "110px",
                          height: "68px",
                          objectFit: "contain",
                        }}
                      ></img>
                    )}
                  </Li>
                  <p
                    className={
                      props?.partner?.url_path === "synergy" ||
                      props?.partner?.url_path === "integrity"
                        ? "px-2 pt-1 m-0"
                        : "px-2 m-0"
                    }
                    style={{ display : props?.partner?.url_path === "bbys" ? 'none' : 'block'}}
                  >
                    +
                  </p>
                </>
              ) : (
                ""
              )}
              {props?.partner?.url_path === "rocketpro"  ?
              <Li
               to={`/${props?.partner?.url_path}`}
               onClick={(e) => {
                 GAEventTracker("Home");
               }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="188" height="34" viewBox="0 0 188 24" fill="none" style={{paddingLeft:'4px'}}>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M47.1177 7.31042C47.1177 11.0973 44.6819 14.1271 40.0385 14.4745L47.8692 22.8045C48.0821 23.0307 47.9216 23.4014 47.6111 23.4014H43.0384C42.9225 23.4014 42.812 23.3526 42.7336 23.2672L34.6809 14.4756H34.4588V23.0481C34.4588 23.2438 34.3001 23.4026 34.1044 23.4026H30.2619C30.0662 23.4026 29.9074 23.2438 29.9074 23.0481V0.48194C29.9074 0.286224 30.0662 0.127463 30.2619 0.127463H40.1192C42.5678 0.114455 47.118 1.83894 47.1177 7.31042ZM34.4585 4.12456V10.8682L38.398 10.8685C39.8449 10.8685 40.9352 10.5613 41.6699 9.95406C42.4034 9.34592 42.7709 8.50482 42.7709 7.43577C42.7709 6.40693 42.4365 5.59657 41.7704 5.00824C41.1017 4.42228 40.1355 4.12456 38.8657 4.12456H34.4585Z" fill="#DE3341">
                </path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M47.4914 14.475C47.4914 9.35923 51.6384 5.21223 56.7542 5.21223C61.87 5.21223 66.017 9.35923 66.017 14.475C66.017 19.5909 61.87 23.7378 56.7542 23.7378C51.6384 23.7378 47.4914 19.5909 47.4914 14.475ZM51.5503 14.4753C51.5503 17.3496 53.88 19.6793 56.7542 19.6793C59.6284 19.6793 61.9581 17.3496 61.9581 14.4753C61.9581 11.6011 59.6284 9.27142 56.7542 9.27142C53.88 9.27142 51.5503 11.6011 51.5503 14.4753Z" fill="#DE3341">
                </path>
                <path d="M131.651 23.0993V20.212C131.651 19.9847 131.441 19.8152 131.219 19.8667C130.036 20.1416 127.443 20.1443 127.443 16.9981V9.03609H131.297C131.493 9.03609 131.652 8.87733 131.652 8.68161V5.87655C131.652 5.68083 131.493 5.52207 131.297 5.52207H127.443V0.477801C127.443 0.199896 127.137 0.0299009 126.902 0.177131L123.079 2.55913C122.975 2.62388 122.912 2.7374 122.912 2.8598V5.52177H120.452C120.257 5.52177 120.098 5.68053 120.098 5.87625V8.68132C120.098 8.87703 120.257 9.03579 120.452 9.03579H122.907V17.3256C122.907 22.8146 127.561 23.7381 129.356 23.7381C130.093 23.7381 130.678 23.6042 131.169 23.4914C131.24 23.4753 131.308 23.4597 131.375 23.4449C131.537 23.4091 131.651 23.2651 131.651 23.0993Z" fill="#DE3341"></path>
                <path d="M103.077 23.4014C103.387 23.4014 103.547 23.0316 103.335 22.8051L95.5506 14.4753L102.623 6.10478C102.817 5.87448 102.653 5.52177 102.352 5.52177H97.9332C97.8108 5.52177 97.6949 5.57588 97.6163 5.66989L91.8276 12.5879H91.5707V0.478688C91.5707 0.200192 91.2644 0.0304922 91.0284 0.178018L87.2052 2.56593C87.1014 2.63068 87.0384 2.7445 87.0384 2.8666V23.0469C87.0384 23.2426 87.1972 23.4014 87.3929 23.4014H91.2162C91.4119 23.4014 91.5707 23.2426 91.5707 23.0469V16.2681H91.7803L98.1697 23.3237C98.2144 23.3733 98.2779 23.4014 98.3447 23.4014H103.077Z" fill="#DE3341"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M106.251 6.45512C107.691 5.63175 109.27 5.21401 110.946 5.21401C114.62 5.21401 117.407 7.19423 118.834 9.58539C120.346 12.1184 120.038 14.7261 119.988 15.1528C119.987 15.1631 119.986 15.1721 119.985 15.1799C119.964 15.3643 119.902 15.6275 119.851 15.8229C119.811 15.9793 119.67 16.0881 119.508 16.0881H105.899C106.023 16.627 106.854 20.0627 110.946 20.0627C112.76 20.0627 114.144 19.2852 114.78 18.5614C114.858 18.4724 114.971 18.4219 115.089 18.4219H118.8C119.067 18.4219 119.238 18.7054 119.115 18.9416C118.303 20.4875 116.808 22.0243 114.702 22.968C113.561 23.4797 112.309 23.739 110.984 23.739C109.258 23.739 107.653 23.3266 106.214 22.516C103.76 21.1329 101.515 18.4136 101.515 14.4756C101.515 14.4707 101.515 14.4636 101.515 14.4543C101.511 14.0343 101.459 9.19333 106.251 6.45512ZM110.947 8.859C108.365 8.859 106.416 10.551 105.871 12.9433H115.797C115.652 12.2415 114.631 8.859 110.947 8.859Z" fill="#DE3341">
                </path>
                <path d="M76.6339 19.6796C73.759 19.6796 71.4296 17.3493 71.4296 14.4753C71.4296 11.6017 73.759 9.27083 76.6342 9.27083C78.889 9.27083 80.8083 10.7059 81.5312 12.7127C81.5809 12.852 81.7145 12.943 81.8632 12.943H85.3394C85.7367 12.943 85.6939 12.5418 85.6814 12.4862C85.643 12.3124 85.5753 12.0484 85.5233 11.8704C84.3989 8.02292 80.8453 5.21223 76.6342 5.21223C71.5183 5.21223 67.3714 9.35923 67.3714 14.475C67.3714 19.5909 71.5183 23.7378 76.6342 23.7378C81.0469 23.7378 84.7354 20.6525 85.6673 16.5209L85.6687 16.515C85.7137 16.2965 85.5449 16.0893 85.3205 16.0893H81.8313C81.6846 16.0893 81.5537 16.1785 81.5016 16.3142C80.7587 18.2812 78.8604 19.6796 76.6339 19.6796Z" fill="#DE3341"></path>
                <path d="M6.63552 12.9058V23.3452C6.63552 23.6217 6.33307 23.7881 6.09685 23.6444C2.48409 21.4457 0.0571532 17.4918 0.000980915 12.967C-0.085347 6.00693 5.5375 0.226513 12.4975 0.129542C19.582 0.031093 25.356 5.7444 25.356 12.8061C25.356 17.4288 22.8817 21.4732 19.1856 23.6882C19.0446 23.7727 18.8627 23.745 18.7501 23.6252L14.4952 19.0968C14.3202 18.9106 14.3959 18.6064 14.6377 18.5236C17.0129 17.7097 18.7205 15.4575 18.7205 12.8064C18.7205 9.43492 15.9592 6.7082 12.5747 6.76467C9.26142 6.81995 6.63552 9.59191 6.63552 12.9058Z" fill="#DE3341"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M149.475 15.0034C154.102 15.0034 156.85 11.236 156.85 7.44907C156.85 1.9773 152.3 0.253106 149.851 0.266114H139.994C139.798 0.266114 139.639 0.424875 139.639 0.620591V23.1868C139.639 23.3825 139.798 23.5412 139.994 23.5412H143.836C144.032 23.5412 144.19 23.3825 144.19 23.1868V15.0045L149.475 15.0034ZM144.19 11.0068V4.26321H148.598C149.867 4.26321 150.834 4.56093 151.502 5.14689C152.168 5.73493 152.503 6.54529 152.503 7.57412C152.503 8.64317 152.135 9.48398 151.402 10.0924C150.667 10.6997 149.577 11.0068 148.13 11.0068H144.19Z" fill="#DE3341"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M178.113 5.35118C172.997 5.35118 168.85 9.49817 168.85 14.6143C168.85 19.7304 172.997 23.8771 178.113 23.8771C183.229 23.8771 187.376 19.7301 187.376 14.6143C187.376 9.49846 183.229 5.35118 178.113 5.35118ZM178.113 19.8182C175.239 19.8182 172.909 17.4885 172.909 14.6143C172.909 11.74 175.239 9.41036 178.113 9.41036C180.987 9.41036 183.317 11.74 183.317 14.6143C183.317 17.4885 180.987 19.8182 178.113 19.8182Z" fill="#DE3341"></path><path d="M158.516 6.01549C158.516 5.81948 158.675 5.66101 158.871 5.66101L162.028 5.66219C162.224 5.66249 162.383 5.82096 162.383 6.01667V7.72638H162.508C163.195 6.8223 164.909 5.35118 167.163 5.35118C167.764 5.35118 168.24 5.40942 168.525 5.45613C168.697 5.48392 168.82 5.63204 168.82 5.80558V8.72388C168.82 8.99764 168.581 9.21021 168.309 9.17474C168.005 9.13512 167.577 9.09728 167.052 9.09728C164.422 9.09728 162.788 10.7674 162.788 13.4557V23.1868C162.788 23.3825 162.629 23.5412 162.433 23.5412H158.871C158.675 23.5412 158.516 23.3825 158.516 23.1868V6.01549Z" fill="#DE3341"></path>
                </svg>
              </Li>
              :
              <Li
                to={`/${props?.partner?.url_path}`}
                onClick={(e) => {
                  GAEventTracker("Home");
                }}
              >
                <img
                  src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                  alt="Logo"
                  width="100px"
                  height="35px"
                  style={{ display : props?.partner?.url_path === "bbys" ? 'none' : 'block'}}
                ></img>
              </Li>
              }
            </div>
          </Typography>
        </div>
        <div className="nav-links-center">
            <Link
              activeclass="active"
              className="NavHeader"
              to="trade"
              spy={true}
              smooth="true"
              offset={-70}
              onClick={(e) => {
                GAEventTrackerHowItWorks("Header", 1);
                handleDesktopHowItWorks();
              }}
              duration={500}
              style={{ fontWeight: "500", color:"black"}}
            >
              How It Works
            </Link>
            <Link
              activeclass="active"
              className="NavHeader"
              to="whyworkwithus"
              spy={true}
              smooth="true"
              offset={-70}
              onClick={(e) => {
                GAEventTrackerHowItWorks("Header", 1);
                handleWhyWorkWithUs();
              }}
              duration={500}
              style={{ fontWeight: "500", color:"black"}}
            >
              Why Work With Us?
            </Link>
            <Link
              activeclass="active"
              className="faqs"
              to="faq"
              spy={true}
              smooth="true"
              offset={-70}
              onClick={(e) => {
                GAEventTrackerFaq("Header", 1);
                handleDesktopFaq();
              }}
              duration={500}
              style={{ fontWeight: "500", color:"black"}}
            >
              FAQs
            </Link>
            </div>
        <div >{/*className="col-6 d-flex justify-content-end align-items-center ipad-res"*/}
          <div >{/*className="w-100 d-flex justify-content-between align-items-center global-nav"*/}
            
            {/* <Link
              activeclass="active"
              //to="/calculator"
              className="NavHeader"
              spy={true}
              smooth="true"
              offset={-70}
              onClick={(e) => {
                GAEventTrackerFaq("Header", 1);
                handleCalculator();
              }}
              duration={500}
              style={{ fontWeight: "500" }}
            >
              CALCULATOR
            </Link> */}
            <Button
              variant="contained"
              disableelevation="true"
              className="navbar-contact-btn"
              disabled={!props?.partner?.url_path}
              onClick={(e) => {
                if (typeof GAEventTrackerContact === "function") {
                  GAEventTrackerContact("Contact Us", 1);
                }
                handleClickOpen2();
              }}
              style={{
                color: "white",
                height:"41px",
                borderRadius:"8px",
                backgroundColor: `${
                  props.partner && props.partner.secondary_color
                    ? props.partner.secondary_color
                    : "#2A83C2"
                }`,
              }}
            >
              Contact
            </Button>
          </div>
        </div>
      </Toolbar>
    );
  };

  useEffect(() => {
    document.addEventListener("click", function (e) {
      setDrawerState(false);
    });
  });

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 822
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  return (
    <AppBar elevation={0} className={`${header} new-navbar`}>
      {mobileView ? mobileNav() : desktopNav()}
      <ModalNewContactUs
        open={openSubmit}
        onClose={handleClickOpen2}
      />
    </AppBar>
  );
}
